// extracted by mini-css-extract-plugin
module.exports =  {"mode":"DVbTNe289HCUlPFAdIbA"};